function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var shared = require('./shared');
var RUN_STORAGE_SCHEMA = "\nCREATE TABLE IF NOT EXISTS snake_daily_seeds (seed INTEGER PRIMARY KEY, day TEXT NOT NULL UNIQUE);\nCREATE TABLE IF NOT EXISTS leaderboard (\n  id INTEGER PRIMARY KEY AUTOINCREMENT,\n  name TEXT NOT NULL COLLATE NOCASE UNIQUE,\n  score INTEGER NOT NULL,\n  eaten INTEGER NOT NULL,\n  achieved_at INTEGER NOT NULL\n);\n\nCREATE INDEX IF NOT EXISTS leaderboard_ranking\nON leaderboard (score DESC, achieved_at ASC);\n\nCREATE TABLE IF NOT EXISTS leaderboard_runs (\n  id INTEGER PRIMARY KEY AUTOINCREMENT,\n  legacy_source_id INTEGER UNIQUE,\n  source TEXT NOT NULL CHECK (source IN ('legacy', 'verified')),\n  ruleset TEXT,\n  run_seed INTEGER,\n  run_steps INTEGER,\n  run_turns TEXT,\n  run_fingerprint TEXT UNIQUE,\n  name TEXT NOT NULL,\n  score INTEGER NOT NULL,\n  eaten INTEGER NOT NULL,\n  achieved_at INTEGER NOT NULL,\n  wallet_public_key TEXT,\n  transaction_signature TEXT UNIQUE,\n  associated_at INTEGER,\n  wallet_failure_code TEXT,\n  repair_state TEXT NOT NULL CHECK (\n    repair_state IN ('not_applicable', 'pending', 'associated', 'abandoned')\n  ),\n  CHECK (\n    (source = 'legacy' AND legacy_source_id IS NOT NULL AND ruleset IS NULL\n      AND run_seed IS NULL AND run_steps IS NULL AND run_turns IS NULL\n      AND run_fingerprint IS NULL AND wallet_public_key IS NULL\n      AND transaction_signature IS NULL AND associated_at IS NULL\n      AND wallet_failure_code IS NULL AND repair_state = 'not_applicable')\n    OR\n    (source = 'verified' AND legacy_source_id IS NULL AND ruleset IS NOT NULL\n      AND run_seed IS NOT NULL AND run_steps IS NOT NULL AND run_turns IS NOT NULL\n      AND run_fingerprint IS NOT NULL)\n  )\n);\n\nCREATE INDEX IF NOT EXISTS leaderboard_runs_ranking\nON leaderboard_runs (score DESC, achieved_at ASC, id ASC);\n\nCREATE TABLE IF NOT EXISTS leaderboard_run_blocks (\n  run_fingerprint TEXT PRIMARY KEY,\n  transaction_signature TEXT NOT NULL UNIQUE,\n  block_id INTEGER NOT NULL CHECK (block_id >= 0),\n  block_hash TEXT NOT NULL CHECK (length(block_hash) = 64),\n  observed_at INTEGER NOT NULL CHECK (observed_at >= 0)\n);\nCREATE TRIGGER IF NOT EXISTS snake_daily_classic_insert BEFORE INSERT ON leaderboard_runs\n WHEN NEW.source='verified' AND EXISTS(SELECT 1 FROM snake_daily_seeds WHERE seed=NEW.run_seed)\n BEGIN SELECT RAISE(ABORT,'daily-seed-private'); END;\nCREATE TRIGGER IF NOT EXISTS snake_daily_classic_update BEFORE UPDATE ON leaderboard_runs\n WHEN NEW.source='verified' AND EXISTS(SELECT 1 FROM snake_daily_seeds WHERE seed=NEW.run_seed)\n BEGIN SELECT RAISE(ABORT,'daily-seed-private'); END;\n\n";
var COPY_LEGACY_SQL = "\nINSERT OR IGNORE INTO leaderboard_runs (\n  legacy_source_id, source, name, score, eaten, achieved_at, repair_state\n)\nSELECT id, 'legacy', name, score, eaten, achieved_at, 'not_applicable'\nFROM leaderboard\n";
var VERIFY_LEGACY_SQL = "\nSELECT\n  (SELECT COUNT(*) FROM leaderboard) AS sourceCount,\n  (SELECT COUNT(*) FROM leaderboard_runs WHERE source = 'legacy') AS legacyCount,\n  (SELECT COUNT(*)\n     FROM leaderboard AS source\n     LEFT JOIN leaderboard_runs AS copied\n       ON copied.legacy_source_id = source.id AND copied.source = 'legacy'\n    WHERE copied.id IS NULL) AS missingCount,\n  (SELECT COUNT(*)\n     FROM leaderboard_runs AS copied\n     LEFT JOIN leaderboard AS source ON source.id = copied.legacy_source_id\n    WHERE copied.source = 'legacy'\n      AND (\n        source.id IS NULL\n        OR copied.name COLLATE BINARY != source.name COLLATE BINARY\n        OR copied.score != source.score\n        OR copied.eaten != source.eaten\n        OR copied.achieved_at != source.achieved_at\n      )) AS valueMismatchCount,\n  (SELECT COUNT(*)\n     FROM leaderboard_runs\n    WHERE source = 'legacy'\n      AND (\n        ruleset IS NOT NULL OR run_seed IS NOT NULL OR run_steps IS NOT NULL\n        OR run_turns IS NOT NULL OR run_fingerprint IS NOT NULL\n        OR wallet_public_key IS NOT NULL OR transaction_signature IS NOT NULL\n        OR associated_at IS NOT NULL OR wallet_failure_code IS NOT NULL\n        OR repair_state != 'not_applicable'\n      )) AS metadataMismatchCount\n";
function isNonNegativeInteger(value) {
  return Number.isSafeInteger(value) && value >= 0;
}
function verifyLegacyMigration(_x, _x2) {
  return _verifyLegacyMigration.apply(this, arguments);
}
function _verifyLegacyMigration() {
  _verifyLegacyMigration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(storage, dbname) {
    var rows, result, values;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return storage.queryDatabase(VERIFY_LEGACY_SQL, {}, dbname);
        case 1:
          rows = _context.v;
          if (!(!Array.isArray(rows) || rows.length !== 1)) {
            _context.n = 2;
            break;
          }
          throw new Error('Legacy migration verification failed.');
        case 2:
          result = rows[0];
          values = [result.sourceCount, result.legacyCount, result.missingCount, result.valueMismatchCount, result.metadataMismatchCount];
          if (!(!values.every(isNonNegativeInteger) || result.sourceCount !== result.legacyCount || result.missingCount !== 0 || result.valueMismatchCount !== 0 || result.metadataMismatchCount !== 0)) {
            _context.n = 3;
            break;
          }
          throw new Error('Legacy migration verification failed.');
        case 3:
          return _context.a(2, Object.freeze({
            sourceCount: result.sourceCount,
            legacyCount: result.legacyCount
          }));
      }
    }, _callee);
  }));
  return _verifyLegacyMigration.apply(this, arguments);
}
function initializeRunStorage(_x3, _x4) {
  return _initializeRunStorage.apply(this, arguments);
}
function _initializeRunStorage() {
  _initializeRunStorage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(storage, dbname) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return storage.executeDatabase(RUN_STORAGE_SCHEMA, dbname);
        case 1:
          _context2.n = 2;
          return storage.runDatabase(COPY_LEGACY_SQL, {}, dbname);
        case 2:
          return _context2.a(2, verifyLegacyMigration(storage, dbname));
      }
    }, _callee2);
  }));
  return _initializeRunStorage.apply(this, arguments);
}
function canonicalEntry(row) {
  if (!row) {
    return null;
  }
  return Object.freeze({
    id: row.id,
    fingerprint: row.fingerprint,
    name: row.name,
    score: row.score,
    eaten: row.eaten,
    achievedAt: row.achievedAt,
    ruleset: row.ruleset,
    run: Object.freeze({
      seed: row.runSeed,
      steps: row.runSteps,
      turns: row.runTurns
    })
  });
}
function findVerifiedEntry(_x5, _x6, _x7) {
  return _findVerifiedEntry.apply(this, arguments);
}
function _findVerifiedEntry() {
  _findVerifiedEntry = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(storage, dbname, fingerprint) {
    var rows;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return storage.queryDatabase("SELECT id, run_fingerprint AS fingerprint, name, score, eaten,\n            achieved_at AS achievedAt, ruleset, run_seed AS runSeed,\n            run_steps AS runSteps, run_turns AS runTurns\n       FROM leaderboard_runs\n      WHERE run_fingerprint = $fingerprint", {
            $fingerprint: fingerprint
          }, dbname);
        case 1:
          rows = _context3.v;
          if (!(!Array.isArray(rows) || rows.length !== 1)) {
            _context3.n = 2;
            break;
          }
          throw new Error('Verified run lookup failed.');
        case 2:
          return _context3.a(2, canonicalEntry(rows[0]));
      }
    }, _callee3);
  }));
  return _findVerifiedEntry.apply(this, arguments);
}
function findVerifiedAssociation(_x8, _x9, _x0) {
  return _findVerifiedAssociation.apply(this, arguments);
}
function _findVerifiedAssociation() {
  _findVerifiedAssociation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(storage, dbname, fingerprint) {
    var rows, row;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return storage.queryDatabase("SELECT id, run_fingerprint AS fingerprint, name, score, eaten,\n            achieved_at AS achievedAt, ruleset, run_seed AS runSeed,\n            run_steps AS runSteps, run_turns AS runTurns,\n            wallet_public_key AS walletPublicKey,\n            transaction_signature AS transactionSignature,\n            associated_at AS associatedAt, repair_state AS repairState\n       FROM leaderboard_runs\n      WHERE source = 'verified' AND run_fingerprint = $fingerprint", {
            $fingerprint: fingerprint
          }, dbname);
        case 1:
          rows = _context4.v;
          if (!(!Array.isArray(rows) || rows.length > 1)) {
            _context4.n = 2;
            break;
          }
          throw new Error('Verified run association lookup failed.');
        case 2:
          if (!(rows.length === 0)) {
            _context4.n = 3;
            break;
          }
          return _context4.a(2, null);
        case 3:
          row = rows[0];
          return _context4.a(2, Object.freeze({
            entry: canonicalEntry(row),
            walletPublicKey: row.walletPublicKey,
            transactionSignature: row.transactionSignature,
            associatedAt: row.associatedAt,
            repairState: row.repairState
          }));
      }
    }, _callee4);
  }));
  return _findVerifiedAssociation.apply(this, arguments);
}
function returnAssociationStatus(_x1, _x10, _x11) {
  return _returnAssociationStatus.apply(this, arguments);
}
function _returnAssociationStatus() {
  _returnAssociationStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(storage, dbname, fingerprint) {
    var association;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          if (!(typeof fingerprint !== 'string' || !/^[a-f0-9]{64}$/.test(fingerprint))) {
            _context5.n = 1;
            break;
          }
          return _context5.a(2, null);
        case 1:
          _context5.n = 2;
          return findVerifiedAssociation(storage, dbname, fingerprint);
        case 2:
          association = _context5.v;
          if (association) {
            _context5.n = 3;
            break;
          }
          return _context5.a(2, null);
        case 3:
          return _context5.a(2, Object.freeze({
            associated: association.repairState === 'associated'
          }));
      }
    }, _callee5);
  }));
  return _returnAssociationStatus.apply(this, arguments);
}
function returnRunProof(_x12, _x13, _x14) {
  return _returnRunProof.apply(this, arguments);
}
function _returnRunProof() {
  _returnRunProof = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(storage, dbname, fingerprint) {
    var rows, row, associated, observed;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          if (!(typeof fingerprint !== 'string' || !/^[a-f0-9]{64}$/.test(fingerprint))) {
            _context6.n = 1;
            break;
          }
          return _context6.a(2, null);
        case 1:
          _context6.n = 2;
          return storage.queryDatabase("SELECT runs.id, runs.run_fingerprint AS fingerprint, runs.name,\n            runs.score, runs.eaten, runs.achieved_at AS achievedAt,\n            runs.ruleset, runs.run_seed AS runSeed, runs.run_steps AS runSteps,\n            runs.run_turns AS runTurns,\n            runs.wallet_public_key AS walletPublicKey,\n            runs.transaction_signature AS transactionSignature,\n            runs.associated_at AS associatedAt, runs.repair_state AS repairState,\n            blocks.block_id AS blockId, blocks.block_hash AS blockHash,\n            blocks.observed_at AS blockObservedAt\n       FROM leaderboard_runs AS runs\n       LEFT JOIN leaderboard_run_blocks AS blocks\n         ON blocks.run_fingerprint = runs.run_fingerprint\n      WHERE runs.source = 'verified' AND runs.run_fingerprint = $fingerprint", {
            $fingerprint: fingerprint
          }, dbname);
        case 2:
          rows = _context6.v;
          if (!(!Array.isArray(rows) || rows.length > 1)) {
            _context6.n = 3;
            break;
          }
          throw new Error('Verified run proof lookup failed.');
        case 3:
          if (!(rows.length === 0)) {
            _context6.n = 4;
            break;
          }
          return _context6.a(2, null);
        case 4:
          row = rows[0];
          associated = row.repairState === 'associated' && typeof row.walletPublicKey === 'string' && row.walletPublicKey && typeof row.transactionSignature === 'string' && row.transactionSignature && Number.isSafeInteger(row.associatedAt) && row.associatedAt >= 0;
          observed = associated && Number.isSafeInteger(row.blockId) && row.blockId >= 0 && typeof row.blockHash === 'string' && /^[a-f0-9]{64}$/.test(row.blockHash) && Number.isSafeInteger(row.blockObservedAt) && row.blockObservedAt >= 0;
          if (!(row.repairState === 'associated' && !associated || !associated && (row.walletPublicKey != null || row.transactionSignature != null || row.associatedAt != null) || row.blockHash != null && !observed)) {
            _context6.n = 5;
            break;
          }
          throw new Error('Verified run proof is inconsistent.');
        case 5:
          return _context6.a(2, Object.freeze({
            entry: canonicalEntry(row),
            verification: Object.freeze({
              state: 'verified',
              method: 'deterministic-replay'
            }),
            chain: Object.freeze({
              state: observed ? 'observed' : associated ? 'associated' : 'pending',
              walletPublicKey: associated ? row.walletPublicKey : null,
              transactionSignature: associated ? row.transactionSignature : null,
              associatedAt: associated ? row.associatedAt : null,
              block: observed ? Object.freeze({
                id: row.blockId,
                hash: row.blockHash,
                observedAt: row.blockObservedAt
              }) : null
            })
          }));
      }
    }, _callee6);
  }));
  return _returnRunProof.apply(this, arguments);
}
function associateVerifiedRun(_x15, _x16, _x17) {
  return _associateVerifiedRun.apply(this, arguments);
}
function _associateVerifiedRun() {
  _associateVerifiedRun = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(storage, dbname, request) {
    var fingerprint, walletPublicKey, transactionSignature, associatedAt, before, _same, result, after, same, _t;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.p = _context7.n) {
        case 0:
          fingerprint = request && request.fingerprint;
          walletPublicKey = request && request.walletPublicKey;
          transactionSignature = request && request.transactionSignature;
          associatedAt = request && request.associatedAt;
          if (!(typeof fingerprint !== 'string' || !/^[a-f0-9]{64}$/.test(fingerprint) || typeof walletPublicKey !== 'string' || walletPublicKey.length < 1 || walletPublicKey.length > 128 || typeof transactionSignature !== 'string' || transactionSignature.length < 1 || transactionSignature.length > 256 || !Number.isSafeInteger(associatedAt) || associatedAt < 0)) {
            _context7.n = 1;
            break;
          }
          return _context7.a(2, Object.freeze({
            status: 'invalid'
          }));
        case 1:
          _context7.n = 2;
          return findVerifiedAssociation(storage, dbname, fingerprint);
        case 2:
          before = _context7.v;
          if (!(!before || before.entry.name !== request.name || !entriesMatchSubmission(before.entry, request))) {
            _context7.n = 3;
            break;
          }
          return _context7.a(2, Object.freeze({
            status: before ? 'conflict' : 'unmatched'
          }));
        case 3:
          if (!(before.repairState === 'associated')) {
            _context7.n = 4;
            break;
          }
          _same = before.walletPublicKey === walletPublicKey && before.transactionSignature === transactionSignature;
          return _context7.a(2, Object.freeze({
            status: _same ? 'associated' : 'conflict',
            duplicate: _same
          }));
        case 4:
          _context7.p = 4;
          _context7.n = 5;
          return storage.runDatabase("UPDATE leaderboard_runs\n          SET wallet_public_key = $walletPublicKey,\n              transaction_signature = $transactionSignature,\n              associated_at = $associatedAt,\n              wallet_failure_code = NULL,\n              repair_state = 'associated'\n        WHERE source = 'verified' AND run_fingerprint = $fingerprint\n          AND wallet_public_key IS NULL AND transaction_signature IS NULL\n          AND repair_state = 'pending'", {
            $walletPublicKey: walletPublicKey,
            $transactionSignature: transactionSignature,
            $associatedAt: associatedAt,
            $fingerprint: fingerprint
          }, dbname);
        case 5:
          result = _context7.v;
          _context7.n = 7;
          break;
        case 6:
          _context7.p = 6;
          _t = _context7.v;
          return _context7.a(2, Object.freeze({
            status: 'conflict'
          }));
        case 7:
          if (!(!result || result.changes !== 0 && result.changes !== 1)) {
            _context7.n = 8;
            break;
          }
          throw new Error('Verified run association update failed.');
        case 8:
          _context7.n = 9;
          return findVerifiedAssociation(storage, dbname, fingerprint);
        case 9:
          after = _context7.v;
          same = after && after.repairState === 'associated' && after.walletPublicKey === walletPublicKey && after.transactionSignature === transactionSignature;
          return _context7.a(2, Object.freeze({
            status: same ? 'associated' : 'conflict',
            duplicate: result.changes === 0 && same
          }));
      }
    }, _callee7, null, [[4, 6]]);
  }));
  return _associateVerifiedRun.apply(this, arguments);
}
function replaceCanonicalBlockEvidence(_x18, _x19, _x20) {
  return _replaceCanonicalBlockEvidence.apply(this, arguments);
}
function _replaceCanonicalBlockEvidence() {
  _replaceCanonicalBlockEvidence = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(storage, dbname, request) {
    var fingerprint, transactionSignature, blockId, blockHash, observedAt, expectedBlockId, expectedBlockHash, conditional, onlyIfUnobserved, association, result, rows, stored, same, _t2;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.p = _context8.n) {
        case 0:
          fingerprint = request && request.fingerprint;
          transactionSignature = request && request.transactionSignature;
          blockId = request && request.blockId;
          blockHash = request && request.blockHash;
          observedAt = request && request.observedAt;
          expectedBlockId = request && request.expectedBlockId;
          expectedBlockHash = request && request.expectedBlockHash;
          conditional = expectedBlockId != null || expectedBlockHash != null;
          onlyIfUnobserved = request && request.onlyIfUnobserved === true;
          if (!(typeof fingerprint !== 'string' || !/^[a-f0-9]{64}$/.test(fingerprint) || typeof transactionSignature !== 'string' || transactionSignature.length < 1 || transactionSignature.length > 256 || !Number.isSafeInteger(blockId) || blockId < 0 || typeof blockHash !== 'string' || !/^[a-f0-9]{64}$/.test(blockHash) || !Number.isSafeInteger(observedAt) || observedAt < 0 || request.onlyIfUnobserved != null && typeof request.onlyIfUnobserved !== 'boolean' || onlyIfUnobserved && conditional || conditional && (!Number.isSafeInteger(expectedBlockId) || expectedBlockId < 0 || typeof expectedBlockHash !== 'string' || !/^[a-f0-9]{64}$/.test(expectedBlockHash)))) {
            _context8.n = 1;
            break;
          }
          return _context8.a(2, Object.freeze({
            status: 'invalid'
          }));
        case 1:
          _context8.n = 2;
          return findVerifiedAssociation(storage, dbname, fingerprint);
        case 2:
          association = _context8.v;
          if (association) {
            _context8.n = 3;
            break;
          }
          return _context8.a(2, Object.freeze({
            status: 'unmatched'
          }));
        case 3:
          if (!(association.repairState !== 'associated' || association.transactionSignature !== transactionSignature)) {
            _context8.n = 4;
            break;
          }
          return _context8.a(2, Object.freeze({
            status: 'conflict',
            duplicate: false
          }));
        case 4:
          _context8.p = 4;
          if (!conditional) {
            _context8.n = 6;
            break;
          }
          _context8.n = 5;
          return storage.runDatabase("UPDATE leaderboard_run_blocks\n            SET block_id = $blockId,\n                block_hash = $blockHash,\n                observed_at = $observedAt\n          WHERE run_fingerprint = $fingerprint\n            AND transaction_signature = $transactionSignature\n            AND block_id = $expectedBlockId\n            AND block_hash = $expectedBlockHash\n            AND (block_id != $blockId OR block_hash != $blockHash)", {
            $fingerprint: fingerprint,
            $transactionSignature: transactionSignature,
            $blockId: blockId,
            $blockHash: blockHash,
            $observedAt: observedAt,
            $expectedBlockId: expectedBlockId,
            $expectedBlockHash: expectedBlockHash
          }, dbname);
        case 5:
          result = _context8.v;
          _context8.n = 10;
          break;
        case 6:
          if (!onlyIfUnobserved) {
            _context8.n = 8;
            break;
          }
          _context8.n = 7;
          return storage.runDatabase("INSERT INTO leaderboard_run_blocks (\n           run_fingerprint, transaction_signature, block_id, block_hash, observed_at\n         ) VALUES (\n           $fingerprint, $transactionSignature, $blockId, $blockHash, $observedAt\n         ) ON CONFLICT(run_fingerprint) DO NOTHING", {
            $fingerprint: fingerprint,
            $transactionSignature: transactionSignature,
            $blockId: blockId,
            $blockHash: blockHash,
            $observedAt: observedAt
          }, dbname);
        case 7:
          result = _context8.v;
          _context8.n = 10;
          break;
        case 8:
          _context8.n = 9;
          return storage.runDatabase("INSERT INTO leaderboard_run_blocks (\n         run_fingerprint, transaction_signature, block_id, block_hash, observed_at\n         ) VALUES (\n           $fingerprint, $transactionSignature, $blockId, $blockHash, $observedAt\n         )\n         ON CONFLICT(run_fingerprint) DO UPDATE SET\n           block_id = excluded.block_id,\n           block_hash = excluded.block_hash,\n           observed_at = excluded.observed_at\n         WHERE leaderboard_run_blocks.transaction_signature = excluded.transaction_signature\n           AND (\n             leaderboard_run_blocks.block_id != excluded.block_id OR\n             leaderboard_run_blocks.block_hash != excluded.block_hash\n           )", {
            $fingerprint: fingerprint,
            $transactionSignature: transactionSignature,
            $blockId: blockId,
            $blockHash: blockHash,
            $observedAt: observedAt
          }, dbname);
        case 9:
          result = _context8.v;
        case 10:
          _context8.n = 12;
          break;
        case 11:
          _context8.p = 11;
          _t2 = _context8.v;
          return _context8.a(2, Object.freeze({
            status: 'conflict',
            duplicate: false
          }));
        case 12:
          if (!(!result || result.changes !== 0 && result.changes !== 1)) {
            _context8.n = 13;
            break;
          }
          throw new Error('Canonical block evidence update failed.');
        case 13:
          _context8.n = 14;
          return storage.queryDatabase("SELECT transaction_signature AS transactionSignature,\n            block_id AS blockId, block_hash AS blockHash, observed_at AS observedAt\n       FROM leaderboard_run_blocks\n      WHERE run_fingerprint = $fingerprint", {
            $fingerprint: fingerprint
          }, dbname);
        case 14:
          rows = _context8.v;
          if (!(!Array.isArray(rows) || rows.length > 1)) {
            _context8.n = 15;
            break;
          }
          throw new Error('Run block evidence verification failed.');
        case 15:
          stored = rows[0];
          same = stored && stored.transactionSignature === transactionSignature && stored.blockId === blockId && stored.blockHash === blockHash;
          if (!((conditional || onlyIfUnobserved) && !same)) {
            _context8.n = 16;
            break;
          }
          return _context8.a(2, Object.freeze({
            status: 'stale',
            duplicate: false
          }));
        case 16:
          return _context8.a(2, Object.freeze({
            status: same ? 'observed' : 'conflict',
            duplicate: result.changes === 0 && Boolean(same)
          }));
      }
    }, _callee8, null, [[4, 11]]);
  }));
  return _replaceCanonicalBlockEvidence.apply(this, arguments);
}
function recordBlockEvidence(_x21, _x22, _x23) {
  return _recordBlockEvidence.apply(this, arguments);
}
function _recordBlockEvidence() {
  _recordBlockEvidence = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(storage, dbname, request) {
    return _regenerator().w(function (_context9) {
      while (1) switch (_context9.n) {
        case 0:
          return _context9.a(2, replaceCanonicalBlockEvidence(storage, dbname, request));
      }
    }, _callee9);
  }));
  return _recordBlockEvidence.apply(this, arguments);
}
function clearCanonicalBlockEvidence(_x24, _x25, _x26) {
  return _clearCanonicalBlockEvidence.apply(this, arguments);
}
function _clearCanonicalBlockEvidence() {
  _clearCanonicalBlockEvidence = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(storage, dbname, request) {
    var fingerprint, transactionSignature, blockId, blockHash, result, rows;
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          fingerprint = request && request.fingerprint;
          transactionSignature = request && request.transactionSignature;
          blockId = request && request.blockId;
          blockHash = request && request.blockHash;
          if (!(typeof fingerprint !== 'string' || !/^[a-f0-9]{64}$/.test(fingerprint) || typeof transactionSignature !== 'string' || transactionSignature.length < 1 || transactionSignature.length > 256 || blockId != null && (!Number.isSafeInteger(blockId) || blockId < 0) || blockHash != null && (typeof blockHash !== 'string' || !/^[a-f0-9]{64}$/.test(blockHash)))) {
            _context0.n = 1;
            break;
          }
          return _context0.a(2, Object.freeze({
            status: 'invalid',
            cleared: false
          }));
        case 1:
          _context0.n = 2;
          return storage.runDatabase("DELETE FROM leaderboard_run_blocks\n      WHERE run_fingerprint = $fingerprint\n        AND transaction_signature = $transactionSignature\n        AND ($blockId IS NULL OR block_id = $blockId)\n        AND ($blockHash IS NULL OR block_hash = $blockHash)", {
            $fingerprint: fingerprint,
            $transactionSignature: transactionSignature,
            $blockId: blockId == null ? null : blockId,
            $blockHash: blockHash == null ? null : blockHash
          }, dbname);
        case 2:
          result = _context0.v;
          if (!(!result || result.changes !== 0 && result.changes !== 1)) {
            _context0.n = 3;
            break;
          }
          throw new Error('Canonical block evidence clear failed.');
        case 3:
          if (!(result.changes === 1)) {
            _context0.n = 4;
            break;
          }
          return _context0.a(2, Object.freeze({
            status: 'cleared',
            cleared: true
          }));
        case 4:
          _context0.n = 5;
          return storage.queryDatabase("SELECT transaction_signature AS transactionSignature,\n            block_id AS blockId, block_hash AS blockHash\n       FROM leaderboard_run_blocks\n      WHERE run_fingerprint = $fingerprint", {
            $fingerprint: fingerprint
          }, dbname);
        case 5:
          rows = _context0.v;
          if (!(!Array.isArray(rows) || rows.length > 1)) {
            _context0.n = 6;
            break;
          }
          throw new Error('Canonical block evidence clear verification failed.');
        case 6:
          if (!(rows.length === 0)) {
            _context0.n = 7;
            break;
          }
          return _context0.a(2, Object.freeze({
            status: 'missing',
            cleared: false
          }));
        case 7:
          if (!(rows[0].transactionSignature !== transactionSignature)) {
            _context0.n = 8;
            break;
          }
          return _context0.a(2, Object.freeze({
            status: 'conflict',
            cleared: false
          }));
        case 8:
          return _context0.a(2, Object.freeze({
            status: 'stale',
            cleared: false
          }));
      }
    }, _callee0);
  }));
  return _clearCanonicalBlockEvidence.apply(this, arguments);
}
function listBlockEvidenceCandidates(_x27, _x28) {
  return _listBlockEvidenceCandidates.apply(this, arguments);
}
function _listBlockEvidenceCandidates() {
  _listBlockEvidenceCandidates = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(storage, dbname) {
    var request,
      limit,
      afterFingerprint,
      rows,
      candidates,
      _args1 = arguments;
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          request = _args1.length > 2 && _args1[2] !== undefined ? _args1[2] : {};
          limit = request && request.limit === undefined ? 100 : request && request.limit;
          afterFingerprint = request && request.afterFingerprint === undefined ? '' : request && request.afterFingerprint;
          if (!(!Number.isSafeInteger(limit) || limit < 1 || limit > 500 || typeof afterFingerprint !== 'string' || afterFingerprint !== '' && !/^[a-f0-9]{64}$/.test(afterFingerprint))) {
            _context1.n = 1;
            break;
          }
          throw new Error('Invalid block evidence page.');
        case 1:
          _context1.n = 2;
          return storage.queryDatabase("SELECT run_fingerprint AS fingerprint,\n            transaction_signature AS transactionSignature,\n            block_id AS blockId, block_hash AS blockHash, observed_at AS observedAt\n       FROM leaderboard_run_blocks\n      WHERE run_fingerprint > $afterFingerprint\n      ORDER BY run_fingerprint ASC\n      LIMIT $limit", {
            $afterFingerprint: afterFingerprint,
            $limit: limit
          }, dbname);
        case 2:
          rows = _context1.v;
          if (Array.isArray(rows)) {
            _context1.n = 3;
            break;
          }
          throw new Error('Block evidence candidate lookup failed.');
        case 3:
          candidates = rows.map(function (row) {
            if (!row || typeof row.fingerprint !== 'string' || !/^[a-f0-9]{64}$/.test(row.fingerprint) || typeof row.transactionSignature !== 'string' || row.transactionSignature.length < 1 || row.transactionSignature.length > 256 || !Number.isSafeInteger(row.blockId) || row.blockId < 0 || typeof row.blockHash !== 'string' || !/^[a-f0-9]{64}$/.test(row.blockHash) || !Number.isSafeInteger(row.observedAt) || row.observedAt < 0) {
              throw new Error('Invalid block evidence candidate.');
            }
            return Object.freeze({
              fingerprint: row.fingerprint,
              transactionSignature: row.transactionSignature,
              blockId: row.blockId,
              blockHash: row.blockHash,
              observedAt: row.observedAt
            });
          });
          return _context1.a(2, Object.freeze(candidates));
      }
    }, _callee1);
  }));
  return _listBlockEvidenceCandidates.apply(this, arguments);
}
function currentRank(_x29, _x30, _x31) {
  return _currentRank.apply(this, arguments);
}
function _currentRank() {
  _currentRank = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(storage, dbname, entry) {
    var rows;
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          _context10.n = 1;
          return storage.queryDatabase("SELECT COUNT(*) + 1 AS rank\n       FROM leaderboard_runs\n      WHERE score > $score\n         OR (score = $score AND achieved_at < $achievedAt)\n         OR (score = $score AND achieved_at = $achievedAt AND id < $id)", {
            $score: entry.score,
            $achievedAt: entry.achievedAt,
            $id: entry.id
          }, dbname);
        case 1:
          rows = _context10.v;
          if (!(!Array.isArray(rows) || rows.length !== 1 || !Number.isSafeInteger(rows[0].rank) || rows[0].rank < 1)) {
            _context10.n = 2;
            break;
          }
          throw new Error('Verified run rank lookup failed.');
        case 2:
          return _context10.a(2, rows[0].rank <= 10 ? rows[0].rank : null);
      }
    }, _callee10);
  }));
  return _currentRank.apply(this, arguments);
}
function entriesMatchSubmission(entry, submission) {
  var replay = submission.replay;
  return Boolean(entry && entry.fingerprint === submission.fingerprint && entry.score === submission.score && entry.eaten === submission.eaten && entry.ruleset === replay.ruleset && entry.run.seed === replay.run.seed && entry.run.steps === replay.run.steps && entry.run.turns === replay.run.turns);
}
function recordVerifiedRun(_x32, _x33, _x34) {
  return _recordVerifiedRun.apply(this, arguments);
}
function _recordVerifiedRun() {
  _recordVerifiedRun = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(storage, dbname, submission) {
    var normalizedName, replay, params, result, entry, _t3, _t4, _t5, _t6;
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          normalizedName = submission && shared.sanitizeName(submission.name);
          replay = submission && shared.normalizeReplay(submission.replay && submission.replay.run, submission.replay && submission.replay.ruleset);
          if (!(!submission || !normalizedName || normalizedName !== submission.name || !Number.isSafeInteger(submission.score) || submission.score < 1 || !Number.isSafeInteger(submission.eaten) || submission.eaten < 1 || !Number.isSafeInteger(submission.achievedAt) || submission.achievedAt < 0 || !replay || typeof submission.fingerprint !== 'string' || !/^[a-f0-9]{64}$/.test(submission.fingerprint))) {
            _context11.n = 1;
            break;
          }
          throw new Error('Invalid verified run storage request.');
        case 1:
          params = {
            $name: submission.name,
            $score: submission.score,
            $eaten: submission.eaten,
            $achievedAt: submission.achievedAt,
            $ruleset: replay.ruleset,
            $runSeed: replay.run.seed,
            $runSteps: replay.run.steps,
            $runTurns: replay.run.turns,
            $fingerprint: submission.fingerprint
          };
          _context11.n = 2;
          return storage.runDatabase("INSERT OR IGNORE INTO leaderboard_runs (\n       source, ruleset, run_seed, run_steps, run_turns, run_fingerprint,\n       name, score, eaten, achieved_at, repair_state\n     ) VALUES (\n       'verified', $ruleset, $runSeed, $runSteps, $runTurns, $fingerprint,\n       $name, $score, $eaten, $achievedAt, 'pending'\n     )", params, dbname);
        case 2:
          result = _context11.v;
          if (!(!result || result.changes !== 0 && result.changes !== 1)) {
            _context11.n = 3;
            break;
          }
          throw new Error('Verified run insert failed.');
        case 3:
          _context11.n = 4;
          return findVerifiedEntry(storage, dbname, submission.fingerprint);
        case 4:
          entry = _context11.v;
          if (entriesMatchSubmission(entry, _objectSpread(_objectSpread({}, submission), {}, {
            replay: replay
          }))) {
            _context11.n = 5;
            break;
          }
          throw new Error('Verified run fingerprint conflict.');
        case 5:
          _t3 = Object;
          _t4 = result.changes === 0;
          _t5 = entry;
          _context11.n = 6;
          return currentRank(storage, dbname, entry);
        case 6:
          _t6 = _context11.v;
          return _context11.a(2, _t3.freeze.call(_t3, {
            duplicate: _t4,
            entry: _t5,
            rank: _t6
          }));
      }
    }, _callee11);
  }));
  return _recordVerifiedRun.apply(this, arguments);
}
function returnLeaderboard(_x35, _x36) {
  return _returnLeaderboard.apply(this, arguments);
}
function _returnLeaderboard() {
  _returnLeaderboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(storage, dbname) {
    var rows;
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          _context12.n = 1;
          return storage.queryDatabase("SELECT name, score, eaten, achieved_at AS achievedAt\n       FROM leaderboard_runs\n      ORDER BY score DESC, achieved_at ASC, id ASC\n      LIMIT 10", {}, dbname);
        case 1:
          rows = _context12.v;
          if (Array.isArray(rows)) {
            _context12.n = 2;
            break;
          }
          throw new Error('Leaderboard lookup failed.');
        case 2:
          return _context12.a(2, rows);
      }
    }, _callee12);
  }));
  return _returnLeaderboard.apply(this, arguments);
}
module.exports = {
  RUN_STORAGE_SCHEMA: RUN_STORAGE_SCHEMA,
  initializeRunStorage: initializeRunStorage,
  verifyLegacyMigration: verifyLegacyMigration,
  recordVerifiedRun: recordVerifiedRun,
  returnAssociationStatus: returnAssociationStatus,
  returnRunProof: returnRunProof,
  associateVerifiedRun: associateVerifiedRun,
  replaceCanonicalBlockEvidence: replaceCanonicalBlockEvidence,
  recordBlockEvidence: recordBlockEvidence,
  clearCanonicalBlockEvidence: clearCanonicalBlockEvidence,
  listBlockEvidenceCandidates: listBlockEvidenceCandidates,
  returnLeaderboard: returnLeaderboard
};